const user = {
  state: {
    userDetal: {},
    accessToken: "",
    appToken: "",
    supInfo: {},
    appList: [],
    catalogList: [], //导购类目列表
    loginInfo: {}
  },

  mutations: {
    SET_ACCESS_TOKEN: (state, token) => {
      state.accessToken = token;
    },
    SET_APP_TOKEN: (state, token) => {
      state.appToken = token;
    },
    SET_SUP_INFO: (state, obj) => {
      state.supInfo = obj;
    },
    SET_CATALOG_LIST: (state, list) => {
      state.catalogList = list;
      console.log(state.catalogList, "state");
    },
    SET_USER_DETAL: (state, obj) => {
      state.userDetal = obj;
    },
    SET_USER_ID: (state, userId) => {
      state.userId = userId;
    },
    SET_APPLIST_INFO: (state, obj) => {
      state.appList = obj;
    },
    SET_LOGIN_INFO: (state, obj) => {
      state.loginInfo = obj;
    }
  },

  actions: {
    setsupinfo({ commit }, response) {
      commit("SET_SUP_INFO", response);
    },
    setLoginInfo({ commit }, response) {
      commit("SET_LOGIN_INFO", response);
    },
    setAppListInfo({ commit }, response) {
      commit("SET_APPLIST_INFO", response);
    }
  },
  getters: {
    getLoginInfo: state => {
      return state.loginInfo;
    },
    getAccessToken: state => {
      return state.accessToken;
    },
    getCatalogList: state => {
      return state.catalogList;
    }
  }
};

export default user;
